var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStakeholdersEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "45px",
    viewBox: "0 0 46 45",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "D1B1FF76-F2EB-4DFF-82F6-586825222C89") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "16.8749561 0 28.1249561 0 28.1249561 11.2499912 16.8749561 11.2499912"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "14.0625951 14.0625088 30.9383812 14.0625088 30.9383812 45 14.0625951 45"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-5",
    points: "30.9374561 0 42.1874561 0 42.1874561 11.2499912 30.9374561 11.2499912"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "2.81245605 0 14.0624561 0 14.0624561 11.2499912 2.81245605 11.2499912"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-9",
    points: "31.2945645 14.0625088 45.0008789 14.0625088 45.0008789 42.1875088 31.2945645 42.1875088"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-11",
    points: "0 14.0624648 13.7136006 14.0624648 13.7136006 42.1874648 0 42.1874648"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User-Management----Stakeholders---Empty",
    transform: "translate(-697.000000, -686.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stakeholders-empty",
    transform: "translate(697.000000, 686.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2",
    opacity: 0.499227834
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4999561,-8.7890625e-06 C25.606626,-8.7890625e-06 28.1249561,2.51840918 28.1249561,5.62499121 C28.1249561,8.73157324 25.606626,11.2499912 22.4999561,11.2499912 C19.393374,11.2499912 16.8749561,8.73157324 16.8749561,5.62499121 C16.8749561,2.51840918 19.393374,-8.7890625e-06 22.4999561,-8.7890625e-06",
    id: "Fill-1",
    fill: "#9C9C9C",
    opacity: 0.499227834,
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5",
    opacity: 0.499227834
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9262148,26.5387588 L29.6493398,16.5937588 C29.5059023,15.1509463 28.3021523,14.0625088 26.8537148,14.0625088 L25.3124648,14.0625088 C24.9384023,14.0625088 24.5812148,14.2115713 24.3168398,14.4731338 L22.4999648,16.2900088 L20.6830898,14.4731338 C20.4187148,14.2115713 20.0615273,14.0625088 19.6874648,14.0625088 L18.1490273,14.0625088 C16.6977773,14.0625088 15.4940273,15.1509463 15.3534023,16.5571963 L14.0737148,26.5415713 C14.0230898,26.9409463 14.1468398,27.3459463 14.4140273,27.6468838 C14.6812148,27.9505459 15.0637148,28.1250088 15.4687148,28.1250088 L16.9874648,28.1250088 L18.1630898,42.4687588 C18.3037148,43.9087588 19.5102773,45.0000088 20.9615273,45.0000088 L24.0412148,45.0000088 C25.4924648,45.0000088 26.6962148,43.9087588 26.8424648,42.4434463 L28.0152773,28.1250088 L29.5312148,28.1250088 C29.9362148,28.1250088 30.3187148,27.9505459 30.5859023,27.6467959 C30.8559023,27.3459463 30.9795645,26.9409463 30.9262148,26.5387588",
    id: "Fill-4",
    fill: "#9C9C9C",
    opacity: 0.499227834,
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-8",
    opacity: 0.499227834
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5624561,-8.7890625e-06 C39.669126,-8.7890625e-06 42.1874561,2.51840918 42.1874561,5.62499121 C42.1874561,8.73157324 39.669126,11.2499912 36.5624561,11.2499912 C33.4557861,11.2499912 30.9374561,8.73157324 30.9374561,5.62499121 C30.9374561,2.51840918 33.4557861,-8.7890625e-06 36.5624561,-8.7890625e-06",
    id: "Fill-7",
    fill: "#9C9C9C",
    opacity: 0.499227834,
    mask: "url(#mask-6)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11",
    opacity: 0.499227834
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.43745605,-8.7890625e-06 C5.33526855,-8.7890625e-06 2.81245605,2.52280371 2.81245605,5.62499121 C2.81245605,8.72717871 5.33526855,11.2499912 8.43745605,11.2499912 C11.5368311,11.2499912 14.0624561,8.72717871 14.0624561,5.62499121 C14.0624561,2.52280371 11.5368311,-8.7890625e-06 8.43745605,-8.7890625e-06",
    id: "Fill-10",
    fill: "#9C9C9C",
    opacity: 0.499227834,
    mask: "url(#mask-8)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-10",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-14",
    opacity: 0.499227834
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9887148,26.5387588 L43.7118398,16.5965713 C43.5684023,15.1509463 42.3674648,14.0625088 40.9162148,14.0625088 L39.3749648,14.0625088 C39.0009023,14.0625088 38.6437148,14.2115713 38.3793398,14.4731338 L36.5624648,16.2900088 L34.7455898,14.4731338 C34.4812148,14.2115713 34.1240273,14.0625088 33.7527773,14.0625088 L32.2115273,14.0625088 C32.0371523,14.0625088 31.8796523,14.1243838 31.7137148,14.1553213 C32.0765273,14.7965713 32.3605898,15.4912588 32.4449648,16.2703213 L33.7190273,26.1815713 C33.8765273,27.3881338 33.4996523,28.6031338 32.6895645,29.5171963 C32.3071523,29.9559463 31.8177773,30.2653213 31.2945645,30.5071963 L32.2283145,39.6562588 C32.3718398,41.0990713 33.5755898,42.1875088 35.0268398,42.1875088 L38.1065273,42.1875088 C39.5577773,42.1875088 40.7615273,41.0962588 40.9077773,39.6309463 L42.0777773,28.1250088 L43.5937148,28.1250088 C43.9987148,28.1250088 44.3812148,27.9506338 44.6484023,27.6468838 C44.9184023,27.3459463 45.0420645,26.9409463 44.9887148,26.5387588",
    id: "Fill-13",
    fill: "#9C9C9C",
    opacity: 0.499227834,
    mask: "url(#mask-10)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-12",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-17",
    opacity: 0.499227834
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3018135,29.5030898 C11.5030635,28.6003652 11.1318135,27.3881777 11.2836885,26.1871523 L12.563376,16.2000527 C12.636501,15.4518398 12.912126,14.7768398 13.2636885,14.1524648 C13.1061885,14.1243398 12.957126,14.0624648 12.7911885,14.0624648 L11.2499385,14.0624648 C10.875876,14.0624648 10.5186885,14.2116152 10.2543135,14.4730898 L8.43743848,16.2900527 L6.62056348,14.4730898 C6.35618848,14.2116152 5.99900098,14.0624648 5.62775098,14.0624648 L4.08641309,14.0624648 C2.63516309,14.0624648 1.43141309,15.1509902 1.29078809,16.5572402 L0.0111005859,26.5416152 C-0.0395244141,26.9409902 0.0842255859,27.3459023 0.351413086,27.6469277 C0.618600586,27.9505898 1.00391309,28.1249648 1.40610059,28.1249648 L2.92485059,28.1249648 L4.10047559,39.6563027 C4.24110059,41.0962148 5.44766309,42.1874648 6.89891309,42.1874648 L9.97860059,42.1874648 C11.4298506,42.1874648 12.6336006,41.0962148 12.7798506,39.6309023 L13.7136006,30.5044277 C13.187751,30.2596523 12.6955635,29.9475527 12.3018135,29.5030898",
    id: "Fill-16",
    fill: "#9C9C9C",
    opacity: 0.499227834,
    mask: "url(#mask-12)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStakeholdersEmpty);
export default __webpack_public_path__ + "static/media/stakeholders-empty.3f7c8e82.svg";
export { ForwardRef as ReactComponent };